(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    root.cvCleanup = () => { controller.abort(); observer?.disconnect(); };
    const one = s => root.querySelector(s);
    const all = s => [...root.querySelectorAll(s)];
    const on = (node, type, fn, options = {}) => node?.addEventListener(type, fn, { ...options, signal });
    const form = one('[data-cv-form]');
    const sticky = one('[data-cv-sticky]');
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { threshold: 0 });
    observer.observe(form);
    let returnFocus;
    function openDialog(dialog) {
      returnFocus = document.activeElement;
      dialog.showModal();
      (dialog.querySelector('h2') || dialog.querySelector('button'))?.focus({ preventScroll: true });
    }
    all('dialog').forEach(dialog => {
      on(dialog, 'close', () => returnFocus?.focus({ preventScroll: true }));
      on(dialog, 'click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.querySelectorAll('[data-cv-close]').forEach(button => on(button, 'click', () => dialog.close()));
    });
    const tickerTrack = one('.cv-ticker-track');
    const tickerCopies = all('.cv-ticker-copy');
    if (tickerTrack && tickerCopies.length === 2) {
      const original = tickerCopies[0].innerHTML;
      const fitTicker = () => {
        tickerCopies[0].innerHTML = original;
        for (let i = 0; i < 8 && tickerCopies[0].getBoundingClientRect().width < window.innerWidth; i++) {
          const repeat = document.createElement('span');
          repeat.className = 'cv-ticker-repeat'; repeat.setAttribute('aria-hidden','true');
          repeat.innerHTML = original; tickerCopies[0].append(repeat);
        }
        tickerCopies[1].innerHTML = tickerCopies[0].innerHTML;
        tickerTrack.style.animationDuration = `${tickerCopies[0].getBoundingClientRect().width / 45}s`;
      };
      fitTicker(); on(window, 'resize', fitTicker);
    }
    on(one('[data-cv-menu-open]'), 'click', () => openDialog(one('[data-cv-menu]')));
    all('[data-cv-menu] nav a').forEach(link => on(link, 'click', () => one('[data-cv-menu]').close()));
    on(one('[data-cv-ticker-pause]'), 'click', event => {
      const button = event.currentTarget;
      const paused = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
      button.textContent = paused ? '▶' : 'Ⅱ';
      one('.cv-ticker').classList.toggle('is-paused', paused);
    });
    const mainImage = one('[data-cv-main-image]');
    const galleryItems = all('.cv-thumbnail[data-cv-image]');
    const galleryStage = one('.cv-image-stage');
    let galleryIndex = Math.max(0, galleryItems.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    let suppressZoomUntil = 0;
    function updateGalleryControls() {
      const controls = one('[data-cv-gallery-controls]');
      if (controls) controls.hidden = galleryItems.length < 2;
      const count = one('[data-cv-gallery-count]');
      if (count) count.textContent = `${galleryIndex + 1} / ${galleryItems.length}`;
    }
    function moveGallery(direction) {
      if (galleryItems.length < 2) return;
      galleryIndex = (galleryIndex + direction + galleryItems.length) % galleryItems.length;
      const image = galleryItems[galleryIndex];
      setImage(image.dataset.cvImage, image.dataset.cvAlt);
    }
    on(one('[data-cv-gallery-prev]'), 'click', () => moveGallery(-1));
    on(one('[data-cv-gallery-next]'), 'click', () => moveGallery(1));
    on(galleryStage, 'keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); moveGallery(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    let gesture;
    on(galleryStage, 'pointerdown', event => {
      if (event.target.closest('[data-cv-gallery-controls]') || event.button !== 0) return;
      gesture = {x:event.clientX, y:event.clientY};
    });
    on(galleryStage, 'pointerup', event => {
      if (!gesture) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        suppressZoomUntil = Date.now() + 400;
        moveGallery(dx < 0 ? 1 : -1);
      }
    });
    on(galleryStage, 'pointercancel', () => { gesture = null; });
    on(mainImage, 'dragstart', event => event.preventDefault());
    updateGalleryControls();
    function setImage(src, alt) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      mainImage.alt = alt || '';
      const index = galleryItems.findIndex(button => button.dataset.cvImage === src);
      if (index >= 0) galleryIndex = index;
      updateGalleryControls();
      all('[data-cv-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.cvImage === src)));
    }
    all('[data-cv-image]').forEach(button => on(button, 'click', () => setImage(button.dataset.cvImage, button.dataset.cvAlt)));
    on(one('[data-cv-zoom]'), 'click', () => {
      if (Date.now() < suppressZoomUntil || !mainImage) return;
      const large = one('[data-cv-large-image]');
      large.src = mainImage.src;
      large.alt = mainImage.alt;
      openDialog(one('[data-cv-lightbox]'));
    });
    all('a[href^="#cv-returns-"], a[href^="#cv-shipping-"], a[href^="#cv-specifications-"]').forEach(link => on(link, 'click', () => {
      const details = root.querySelector(link.getAttribute('href'));
      if (details) details.open = true;
    }));
    all('[data-pw-finish]').forEach(button => on(button, 'click', () => {
      setImage(button.dataset.pwImage, `Aluminium carry-on in ${button.dataset.pwFinish.toLowerCase()}`);
      one('[data-pw-finish-label]').textContent = button.dataset.pwFinish;
      all('[data-pw-finish]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    on(one('[data-pw-fit]'), 'submit', event => {
      event.preventDefault();
      const inputs = event.currentTarget.elements;
      const limits = [1,2,3].map(n => Number(inputs[`dimension-${n}`].value)).sort((a,b) => b-a);
      const weight = Number(inputs.weight.value);
      const fits = [56,36,22].every((size,i) => size <= limits[i]);
      const allowance = Math.round((weight - 4.5) * 10) / 10;
      const result = one('[data-pw-fit-result]');
      result.hidden = false;
      result.dataset.fits = String(fits && allowance > 0);
      result.textContent = `${fits ? 'The case dimensions fit within the limits you entered.' : 'The case exceeds at least one dimension you entered.'} ${allowance > 0 ? `You have approximately ${allowance} kg left for contents within that weight limit.` : allowance === 0 ? 'The empty case uses the entire weight allowance.' : 'The empty case exceeds that weight allowance.'} Confirm your airline’s current rules before travelling.`;
    });
    const dataNode = one('[data-cv-product]');
    if (!dataNode) return; // A labelled, non-purchasable preview when no product is selected.
    const data = JSON.parse(dataNode.textContent);
    const currency = data.currency || 'AUD';
    const formatter = new Intl.NumberFormat(data.locale || 'en', { style: 'currency', currency, currencyDisplay: 'code' });
    const money = cents => formatter.format(cents / 100);
    const apiRoot = (data.root || '/').replace(/\/?$/, '/');
    const quantity = form.elements.quantity;
    const variantId = one('[data-cv-id]');
    const groups = all('[data-cv-option]');
    const error = one('[data-cv-error]');
    const stock = one('[data-cv-stock]');
    let current = data.variants.find(v => v.id === data.defaultVariant) || data.variants[0];
    let busy = false;
    function inventory(v, count) {
      if (!v || !v.available) return { state: 'unavailable', label: v ? 'Sold out' : 'This combination is unavailable' };
      if (v.dispatch) return { state: 'backorder', label: `Backorder · Estimated dispatch ${v.dispatch}` };
      if (v.managed && v.continue && count > v.stock) return { state: 'backorder', label: 'Backorder · Dispatch date to be confirmed' };
      return { state: 'available', label: v.managed && !v.continue && v.stock > 0 && v.stock <= 5 ? `Only ${v.stock} left in stock` : v.managed ? 'In stock' : 'Available to order' };
    }
    function limits(v) {
      const min = v?.min || 1, step = v?.increment || 1;
      let max = v?.max ?? Infinity;
      if (v?.managed && !v.continue) max = Math.min(max, Math.max(0, v.stock));
      return { min, step, max };
    }
    function render() {
      const v = current;
      const count = Number(quantity.value) || 1;
      const state = inventory(v, count);
      stock.textContent = state.label;
      stock.dataset.state = state.state;
      variantId.value = v ? String(v.id) : '';
      const express = one('[data-cv-express]');
      if (express) {
        const validQty = Number.isInteger(count) && count >= limits(v).min && count <= limits(v).max && (count - limits(v).min) % limits(v).step === 0;
        express.hidden = busy || !v?.available || data.requiresPlan || !validQty;
        const expressId = one('[data-cv-express-id]');
        const expressQty = one('[data-cv-express-quantity]');
        expressId.value = v ? String(v.id) : '';
        expressQty.value = String(count);
        expressId.dispatchEvent(new Event('change', { bubbles: true }));
        expressQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const rule = limits(v);
      quantity.min = rule.min;
      quantity.step = rule.step;
      if (Number.isFinite(rule.max)) quantity.max = rule.max; else quantity.removeAttribute('max');
      all('[data-cv-qty]').forEach(b => { b.disabled = busy || !v?.available || (Number(b.dataset.cvQty) < 0 ? count <= rule.min : count + rule.step > rule.max); });
      all('[data-cv-add]').forEach(b => {
        b.disabled = busy || !v?.available || data.requiresPlan;
        b.setAttribute('aria-busy', String(busy));
        b.querySelector('[data-cv-add-label]').textContent = !v ? 'Unavailable' : !v.available ? 'Sold out' : state.state === 'backorder' ? 'Pre-order' : 'Add to cart';
      });
      if (v) {
        ['[data-cv-price]', '[data-cv-sticky-price]', '[data-cv-final-price]'].forEach(s => { one(s).textContent = money(v.price); });
        const compare = one('[data-cv-compare]'), saving = one('[data-cv-saving]');
        compare.hidden = saving.hidden = !(v.compare > v.price);
        compare.textContent = money(v.compare);
        saving.textContent = `Save ${money(v.compare - v.price)}`;
      }
      one('[data-cv-sticky-options]').textContent = groups.length ? groups.map(g => g.querySelector('input:checked')?.value || '').join(' / ') : '';
      const selected = groups.map(g => g.querySelector('input:checked')?.value);
      groups.forEach((group, index) => {
        group.querySelector('[data-cv-option-label]').textContent = selected[index] || '';
        group.querySelectorAll('input').forEach(input => {
          const possible = data.variants.some(candidate => candidate.available && candidate.options[index] === input.value && candidate.options.every((value, i) => i >= index || value === selected[i]));
          input.closest('label').classList.toggle('is-unavailable', !possible);
          input.title = possible ? input.value : `${input.value} — unavailable with the preceding options`;
        });
      });
    }
    groups.forEach((group, index) => on(group, 'change', () => {
      if (busy) return;
      error.hidden = true;
      const selected = groups.map(g => g.querySelector('input:checked')?.value);
      current = data.variants.find(v => v.options.every((value, i) => value === selected[i]));
      // Preserve earlier choices; pick a valid remaining combination when needed.
      if (!current) {
        current = data.variants.find(v => v.available && v.options.every((value, i) => i > index || value === selected[i])) || data.variants.find(v => v.options.every((value, i) => i > index || value === selected[i]));
        if (current) groups.forEach((g, i) => g.querySelectorAll('input').forEach(input => { input.checked = input.value === current.options[i]; }));
      }
      const rule = limits(current);
      quantity.value = rule.min;
      render();
      if (current?.image) setImage(current.image, `${data.title} — ${current.title}`);
    }));
    all('[data-cv-qty]').forEach(button => on(button, 'click', () => {
      if (busy) return;
      const { min, max, step } = limits(current);
      quantity.value = Math.max(min, Math.min(max, (Number(quantity.value) || min) + Number(button.dataset.cvQty) * step));
      render();
    }));
    on(quantity, 'input', render);
    const setBusy = value => {
      busy = value;
      quantity.disabled = value;
      groups.forEach(g => { g.disabled = value; });
      render();
    };
    on(form, 'submit', async event => {
      event.preventDefault();
      if (busy || !current?.available || data.requiresPlan || !form.reportValidity()) return;
      const selected = current;
      const count = Number(quantity.value);
      const rule = limits(selected);
      if (!Number.isInteger(count) || count < rule.min || count > rule.max || (count - rule.min) % rule.step !== 0) return;
      error.hidden = true;
      setBusy(true);
      let added = false;
      try {
        const properties = selected.dispatch ? { 'Estimated dispatch': selected.dispatch } : {};
        const response = await fetch(`${apiRoot}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: selected.id, quantity: count, properties }] }) });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'This item could not be added. Please check your selection.');
        added = true;
        one('[data-cv-added-summary]').textContent = `${count} × ${data.title}${groups.length ? ` — ${selected.title}` : ''}`;
        const total = one('[data-cv-cart-total]');
        total.textContent = 'Confirmed at checkout';
        try {
          const cartResponse = await fetch(`${apiRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!cartResponse.ok) throw new Error('Cart read failed');
          const cart = await cartResponse.json();
          total.textContent = money(cart.total_price);
          one('[data-cv-cart-count]').textContent = cart.item_count;
        } catch (_) { /* Addition is confirmed: never encourage a duplicate retry. */ }
        if (window.PortwellCart) await window.PortwellCart.open();
        else openDialog(one('[data-cv-cart-dialog]'));
        root.dispatchEvent(new CustomEvent('conversion:add-to-cart', { bubbles: true, detail: { product: data.title, variantId: selected.id, quantity: count, currency, value: selected.price * count / 100 } }));
      } catch (failure) {
        error.textContent = added ? 'Your item was added. Open your cart to continue.' : failure instanceof TypeError || failure instanceof SyntaxError ? 'We couldn’t confirm the cart update. Check your cart before trying again.' : failure.message;
        error.hidden = false;
        error.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      } finally { setBusy(false); }
    });
    // Keep the native form usable without JavaScript; hide its fallback only after setup.
    render();
    root.classList.add('is-ready');
  }
  const run = scope => scope.querySelectorAll('[data-conversion]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document)); else run(document);
  document.addEventListener('shopify:section:load', event => run(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-conversion]').forEach(root => root.cvCleanup?.()));
})();
